/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ComponentBluePrintDataContext } from '../models/component-blue-print-data-context';
import { ComponentJsonRoot } from '../models/component-json-root';
import { FeatureFlagsAndLanguageDropdownResponse } from '../models/feature-flags-and-language-dropdown-response';

@Injectable({
  providedIn: 'root',
})
export class CareFindrTenantConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTenantComponentJs
   */
  static readonly GetTenantComponentJsPath = '/tenants/{tenant}/component-js';

  /**
   * GET Tenant specific Component JSON.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantComponentJs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentJs$Response(params: {

    /**
     * The tenant key used to look up config. Falls back to the default config if the specified tenant is not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ComponentJsonRoot>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantComponentJsPath, 'get');
    if (params) {
      rb.path('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentJsonRoot>;
      })
    );
  }

  /**
   * GET Tenant specific Component JSON.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantComponentJs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentJs(params: {

    /**
     * The tenant key used to look up config. Falls back to the default config if the specified tenant is not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<ComponentJsonRoot> {

    return this.getTenantComponentJs$Response(params,context).pipe(
      map((r: StrictHttpResponse<ComponentJsonRoot>) => r.body as ComponentJsonRoot)
    );
  }

  /**
   * Path part for operation getAzureFeatureFlag
   */
  static readonly GetAzureFeatureFlagPath = '/carefindr-azure-api/feature-flag/{featureFlagName}';

  /**
   * GET Azure Feature Flag value — proxied through the server so keys are never exposed to the client.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAzureFeatureFlag()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAzureFeatureFlag$Response(params: {

    /**
     * The feature-flag key/name to look up in Azure App Configuration.
     */
    featureFlagName: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetAzureFeatureFlagPath, 'get');
    if (params) {
      rb.path('featureFlagName', params.featureFlagName, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * GET Azure Feature Flag value — proxied through the server so keys are never exposed to the client.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAzureFeatureFlag$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAzureFeatureFlag(params: {

    /**
     * The feature-flag key/name to look up in Azure App Configuration.
     */
    featureFlagName: string;
  },
  context?: HttpContext

): Observable<boolean> {

    return this.getAzureFeatureFlag$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation getCarefinDrConfig
   */
  static readonly GetCarefinDrConfigPath = '/carefindr-azure-api/config/{configKey}';

  /**
   * GET a whitelisted CarefinDr configuration value. Currently supports: GoogleApiKey.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarefinDrConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarefinDrConfig$Response(params: {

    /**
     * The whitelisted configuration key to retrieve.
     */
    configKey: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetCarefinDrConfigPath, 'get');
    if (params) {
      rb.path('configKey', params.configKey, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * GET a whitelisted CarefinDr configuration value. Currently supports: GoogleApiKey.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarefinDrConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarefinDrConfig(params: {

    /**
     * The whitelisted configuration key to retrieve.
     */
    configKey: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getCarefinDrConfig$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getTenantComponentBluePrint
   */
  static readonly GetTenantComponentBluePrintPath = '/component-blueprint/{page_name}';

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantComponentBluePrint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentBluePrint$Response(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ComponentBluePrintDataContext>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantComponentBluePrintPath, 'get');
    if (params) {
      rb.path('page_name', params.page_name, {});
      rb.header('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentBluePrintDataContext>;
      })
    );
  }

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantComponentBluePrint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantComponentBluePrint(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<ComponentBluePrintDataContext> {

    return this.getTenantComponentBluePrint$Response(params,context).pipe(
      map((r: StrictHttpResponse<ComponentBluePrintDataContext>) => r.body as ComponentBluePrintDataContext)
    );
  }

  /**
   * Path part for operation getTenantBluePrint
   */
  static readonly GetTenantBluePrintPath = '/Ui-blueprint/{page_name}';

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantBluePrint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantBluePrint$Response(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantBluePrintPath, 'get');
    if (params) {
      rb.path('page_name', params.page_name, {});
      rb.header('tenant', params.tenant, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * GET Tenant specific ComponentBlueprint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantBluePrint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantBluePrint(params: {

    /**
     * Specifies the name of the page for which the component blueprint is being retrieved.
     */
    page_name: string;

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB. Falls-back to default config if specified tenant not found.
     */
    tenant: string;

    /**
     * Specifies the language for the blueprint. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getTenantBluePrint$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getTenantFeatureFlags
   */
  static readonly GetTenantFeatureFlagsPath = '/Ui-featureflags';

  /**
   * GET Tenant specific FeatureFlags and LanguageDropdownResponse.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantFeatureFlags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantFeatureFlags$Response(params: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FeatureFlagsAndLanguageDropdownResponse>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantFeatureFlagsPath, 'get');
    if (params) {
      rb.header('tenant', params.tenant, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FeatureFlagsAndLanguageDropdownResponse>;
      })
    );
  }

  /**
   * GET Tenant specific FeatureFlags and LanguageDropdownResponse.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantFeatureFlags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantFeatureFlags(params: {

    /**
     * The tenant name we will use as a key to lookup their config in MongoDB.
     */
    tenant: string;
  },
  context?: HttpContext

): Observable<FeatureFlagsAndLanguageDropdownResponse> {

    return this.getTenantFeatureFlags$Response(params,context).pipe(
      map((r: StrictHttpResponse<FeatureFlagsAndLanguageDropdownResponse>) => r.body as FeatureFlagsAndLanguageDropdownResponse)
    );
  }

  /**
   * Path part for operation getTenantSpecialties
   */
  static readonly GetTenantSpecialtiesPath = '/Ui-specialties';

  /**
   * GET Tenant specific Specialties with translations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTenantSpecialties()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantSpecialties$Response(params: {

    /**
     * The tenant name we will use as a key to lookup their specialties in MongoDB.
     */
    tenant: string;

    /**
     * The ConfiguredPlans to filter specialties. Optional.
     */
    ConfiguredPlans?: string;

    /**
     * Specifies the language for the specialty translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, CareFindrTenantConfigurationService.GetTenantSpecialtiesPath, 'get');
    if (params) {
      rb.header('tenant', params.tenant, {});
      rb.query('ConfiguredPlans', params.ConfiguredPlans, {});
      rb.header('Accept-Language', params['Accept-Language'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * GET Tenant specific Specialties with translations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTenantSpecialties$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTenantSpecialties(params: {

    /**
     * The tenant name we will use as a key to lookup their specialties in MongoDB.
     */
    tenant: string;

    /**
     * The ConfiguredPlans to filter specialties. Optional.
     */
    ConfiguredPlans?: string;

    /**
     * Specifies the language for the specialty translations. Defaults to 'en' if not provided. Example: 'en', 'es', 'fr'
     */
    'Accept-Language'?: string;
  },
  context?: HttpContext

): Observable<{
}> {

    return this.getTenantSpecialties$Response(params,context).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
